import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from "@/router";

export default {
    name: 'educationTestArchived',

    data() {
        return {
            quiz: {},
            answer: {},
            answers: [],
            quizCount: 0
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Gets the education video from API
         */
        getQuiz() {
            api.get(`/api/get_archived_promotion_education_quiz/${this.$route.params.id}`)
                .then((response) => {
                    this.quiz = response.data.body.entries;
                    this.answer = response.data.body.entries.answers[this.quizCount];

                    if (!this.quiz.active && this.quiz.archived) {
                        router.replace('/education/tests')
                    }
                });
        },

        nextAnswer() {
            this.answers = [];
            this.quizCount = this.quizCount + 1;
            this.answer = this.quiz.answers[this.quizCount];
        }
    },

    mounted() {
        this.getQuiz();
    },
}
